import React from 'react'
import i18n from 'simple-react-i18n'
import { Box, Grid } from '@mui/material'
import { HYDRO_IMPORT_TYPE } from 'hydrometry/constants/HydrometryConstants'
import DtoHydrometricStation from 'hydrometry/dto/DtoHydrometricStation'
import AddHydroStepOptionsHP from './AddHydroStepOptionsHP'
import PropTypes from 'prop-types'
import AddStepOptionsEmpty from 'station/components/addSteps/AddStepOptionsEmpty'
import { IMPORT_TYPE } from '../../../../traitements/constants/TraitementConstants'
import AddHydroStepOptionsMareGraphe from './AddHydroStepOptionsMareGraphe'

const AddHydroStepOptions = ({
    station,
    ...props
}) => {
    const getOptionsPanel = () => {
        switch (station.stationType) {
            default: case HYDRO_IMPORT_TYPE.HYDRO_PORTAIL:
                return <AddHydroStepOptionsHP {...props} station={station} />
            case HYDRO_IMPORT_TYPE.EMPTY:
                return <AddStepOptionsEmpty {...props} station={station} stationType='hydrometry'/>
            case IMPORT_TYPE.TIDE_GAUGE:
                return <AddHydroStepOptionsMareGraphe {...props} station={station} />
        }
    }
    return (
        <Box paddingTop={1}>
            <Grid container justifyContent='center' alignItems='center' spacing={3}>
                <h4>{i18n.newStationStep2}</h4>
            </Grid>
            { getOptionsPanel() }
        </Box>
    )
}

AddHydroStepOptions.propTypes = {
    station: PropTypes.instanceOf(DtoHydrometricStation),
}

export default AddHydroStepOptions